// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o7-1";
export var stateContainer = "_o7-0";